var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBlogTripTeaserSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#19f59b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.85,47.38c29.8,23.32,30.37,24.19,34.94,39.85,1.83,6.26,2.72,12.7,1.32,18.77-1.68,7.3-6.58,13.71-12.05,19.58-35,37.58-98.12,58.15-162.18,52.84-26.4-2.18-53.19-8.66-75.8-20.79s-40.67-30.25-46.51-50.14A60.29,60.29,0,0,1,96,77.27c7.68-34.64,41.58-63.21,85.85-72.37a105,105,0,0,1,25.52-2.41c14.68.6,29.07,5.15,43.09,9.63C286.75,23.74,327.05,24.06,356.85,47.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.24,26.72c-.91,8.84-1,16.07,8.54,28.85C13.06,58.62,22.84,66,25,66.94c11.6,4.94,27,3.14,39-4.56a36.78,36.78,0,0,0,9-7.93,28.08,28.08,0,0,0,5.85-20.66A32.21,32.21,0,0,0,70,15.89c-11.19-12-30-17-48.32-13.1a25.35,25.35,0,0,0-8.32,3.08A22.13,22.13,0,0,0,7.93,11C4.11,15.76,2.24,26.72,2.24,26.72Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlogTripTeaserSmall);
export default __webpack_public_path__ + "static/media/bg_blog_trip_teaser_small.3d55e7291913cf4a232f4a2e4d4e5533.svg";
export { ForwardRef as ReactComponent };